import ContactPerson from '../ContactPerson/ContactPerson';
import type { PressContactListProps } from './interfaces';
import styles from './PressContactList.module.scss';

const PressContactList = ({ items }: PressContactListProps) => {
  const pressContacts = items.map((props) => {
    return <ContactPerson key={props.name} {...props} />;
  });

  return <div className={styles.base}>{pressContacts}</div>;
};

export default PressContactList;
